import React from "react";

function WebsitePrivacyPolicy() {

  return (
    <div className="privacy-page-section">
      <div className="heading-banner-page">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">Terms & Conditions</li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="innerpage-padding">
        <div className="container">
          <div className="cms-content">
            <h3>Website Introduction</h3>
            <p>Welcome to our website. We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit or interact with our site. Please take a moment to read through our policy to understand how we handle your information.</p>

            <p>We use advanced security measures to ensure your personal data remains protected. By using our website, you consent to the practices described in this Privacy Policy.</p>

            <h3>Acceptance of Terms</h3>
            <p>By accessing and using our website, you agree to be bound by the terms outlined in this Privacy Policy. If you do not agree with any part of this policy, please refrain from using our site. We reserve the right to update or change this policy, and it is recommended that you review it periodically to stay informed of any updates.</p>

            <h5>01. Information We Collect</h5>
            <p>We collect personal information such as your name, email address, phone number, and payment information when you sign up, place an order, or interact with our services. We may also gather non-personal data such as IP addresses and browsing behavior to improve our website's functionality.</p>

            <h5>02. How We Use Your Information</h5>
            <p>We use the information we collect to process transactions, improve user experience, communicate with you, and provide customer support. We may also use your data to send marketing materials or updates, but you can opt out of these communications at any time.</p>

            <h5>03. Data Protection and Security</h5>
            <p>We take the security of your personal information seriously. We employ various security technologies and procedures to protect your data from unauthorized access, use, or disclosure. However, no method of transmission over the internet is 100% secure, so we cannot guarantee absolute security.</p>

            <h5>04. Sharing Your Information</h5>
            <p>We do not sell or rent your personal information to third parties. We may share your data with trusted partners who assist us in providing services, such as payment processors or shipping companies, but they are obligated to keep your information confidential and use it solely for the purpose of fulfilling your request.</p>

            <h5>05. Cookies and Tracking Technologies</h5>
            <p>Our website uses cookies to enhance user experience and track activity. You can choose to disable cookies in your browser settings, but this may affect your ability to use certain features of our site.</p>

            <h5>06. Your Rights</h5>
            <p>You have the right to access, update, or delete your personal information. If you wish to make changes to your data or if you have any concerns about your privacy, please contact us at any time, and we will assist you in accordance with applicable privacy laws.</p>

            <h5>07. Changes to Our Privacy Policy</h5>
            <p>We may update this Privacy Policy from time to time. Any changes will be reflected on this page, and the date of the most recent update will be posted at the top of the policy. We encourage you to review the policy periodically to stay informed about how we are protecting your data.</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default WebsitePrivacyPolicy;